export var AUTH_TAB;
(function (AUTH_TAB) {
    AUTH_TAB["OTP_LOGIN"] = "OTP_LOGIN";
    AUTH_TAB["OTP_SIGNUP"] = "OTP_SIGNUP";
    AUTH_TAB["LOGIN"] = "LOGIN";
    AUTH_TAB["SIGN_UP"] = "SIGNUP";
    AUTH_TAB["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
})(AUTH_TAB || (AUTH_TAB = {}));
